import axios from 'axios'
import { isNull, isObject, isEmpty, map, get, each, find, differenceWith, includes, slice, reverse } from 'lodash'

export const getPage = (id) => {
  const user = find(window.drupalSettings.nclc_book.bookReader.data, (item) => {
    return item.type === 'user'
  })

  const storage = sessionStorage.getItem(`NclclBookReader.subsection:${user.id}_${id}`)
  return Promise.resolve(JSON.parse(storage))
}


export const getPages = (ids, book = false, first = true) => {
  const user = find(window.drupalSettings.nclc_book.bookReader.data, (item) => {
    return item.type === 'user'
  })
  const storage = map(ids, (id) => {
    return isNull(sessionStorage.getItem(`NclclBookReader.subsection:${user.id}_${id}`)) ? id : sessionStorage.getItem(`NclclBookReader.subsection:${user.id}_${id}`)
  })

  const existingContent = storage.map((item) => {
    return JSON.parse(item)
  })
  const getContent = existingContent.filter((item) => {
    return isObject(item)
  })

  let diff = []
  if (!book) {
    const filterContent = ids.filter((i) => {
      return find(getContent, (storedContent) => {
        return storedContent.id === i
      })
    })
    if (first) {
      diff = ids
    } else {
      diff = differenceWith(ids, filterContent)
    }
  } else if (!isEmpty(getContent)) {
    diff = []
  } else {
    diff = ids
  }

  let pageTypePath = '/bookreader/subsections?ids='
  if (book) {
    pageTypePath = `/bookreader/companion_material/${get(book, 'id')}`
  }
  if (!isEmpty(diff)) {
    const diffmap = `${diff.map((i) => { return `${i}` })}`
    return axios.get(`${pageTypePath}${diffmap}`).then((page) => {
      // Delete all pages out of the local cache. We have too much data and we
      // will fill it up. Only worry about what is part of the current scrolling
      // window.
      if (page.data.data.length > 0) {
        var n = sessionStorage.length
        while(n--) {
          var key = sessionStorage.key(n)
          if(/NclclBookReader.subsection:/.test(key)) {
            sessionStorage.removeItem(key)
          }
        }

        if (book) {
          sessionStorage.setItem(`NclclBookReader.subsection:${user.id}_${diffmap}`, JSON.stringify(get(page, 'data.data')))
        } else {
          each(get(page, 'data.data'), (item) => {
            if (!isEmpty(item) && get(item, 'id', false)) {
              sessionStorage.setItem(`NclclBookReader.subsection:${user.id}_${item.id}`, JSON.stringify(item))
            }
          })
        }
      }
      else {
        const subsectionIds = page.config.url.split(pageTypePath).pop().split(',');
        if (subsectionIds && subsectionIds.length > 0) {
          for (let i = 0; i < subsectionIds.length; i++) {
            if (ids.indexOf(subsectionIds[i]) > -1) {
              ids.splice(ids.indexOf(subsectionIds[i]), 1)
            }
          }
        }
      }
      return getPages(ids, book, false)
    })
  }
  if (book) {
    return Promise.resolve(getContent)
  }
  return Promise.resolve([...getContent])
}
